import { Link } from "react-router-dom";
import { usePublicJobOpenings } from "../../hooks/usePublicJobOpenings";
import {
  jobsNoticeTitle,
  shouldShowJobsNotice,
} from "../../data/jobOpeningPublic";

/**
 * Thin Airon notice on the homepage — not PMNotice (Tailwind/FAQ)
 * and not a second careers grid. Hidden while loading and when the
 * public list is empty (no “we’re hiring” lie).
 */
export function JobsNotice() {
  const { items, loading } = usePublicJobOpenings({ per_page: 50 });

  if (!shouldShowJobsNotice({ loading, items })) return null;

  const count = items.length;
  const title = jobsNoticeTitle(count);

  return (
    <section className="jobs-notice-sec" aria-label="Ledige stillinger">
      <div className="wrap">
        <div className="jobs-notice">
          <div className="jobs-notice-copy">
            <div className="jobs-notice-tag">Karriere</div>
            <p className="jobs-notice-title">{title}</p>
          </div>
          <Link to="/stillinger" className="btn">
            Se stillinger
            <span className="arr">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
